import 'jquery';
import Turbolinks from 'turbolinks';

const adjustHeight = () => {
	if (window.innerHeight < 660)
		return;

	if (document.body.clientWidth > 720) {
		$('.partner-dashboard > .row').height(window.innerHeight - 110);
		$('.partner-dashboard .news-wrapper').css('max-height', window.innerHeight - 510);
	}
	else {
		$('.partner-dashboard .news-wrapper').css('max-height', null);
	}
};

const onLoad = () => {
	const scope = $('#scope-portfolio-view').val();

	if (scope !== 'partner')
		return;

	adjustHeight();
	$(window).resize(adjustHeight);
}

$(() => {
	onLoad();
	document.addEventListener('turbolinks:load', onLoad);
});